import { IPostsListResponse } from '@sapientpro/sapientpro-data-models';
import client from '../../../apiClient';

export const BLOG_POSTS_LIMIT = 18;

type GetArticlesParams = {
  search?: string;
  category?: string;
  limit: number;
  offset: number;
};

export const getArticles = async ({
  search,
  category,
  limit,
  offset,
}: GetArticlesParams) => {
  try {
    return await client.get<IPostsListResponse>(
      `posts?${new URLSearchParams(JSON.parse(JSON.stringify({
        limit,
        offset,
        us: false,
        ...(search ? { search } : {}),
        ...(category ? { category } : {}),
      })))}`,
      {
        cache: 'no-cache',
      },
    );
  } catch (e) {
    console.error(e.message);
  }
};
